import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { StyledButton, StyledPopper } from './StyledComponents'; // Import styled components from a separate file
import useEmployeeData from 'containers/pages/timesheets/hooks/useEmployeeData';
import { Employee } from 'containers/pages/timesheets/types/employee';
import { EditIcon } from 'components/icons';
import AutocompleteComponent from './AutocompleteComponent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Box } from '@mui/material';

interface FloatingEmployeeSelectorProps {
	updateEmployeeInFilter: (value: Employee | null) => void;
}

export default function FloatingEmployeeSelector(
	props: FloatingEmployeeSelectorProps,
) {
	const { updateEmployeeInFilter } = props;
	const { employees, loadingEmployees } = useEmployeeData();
	const [value, setValue] = React.useState<Employee | null>(null);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [pendingValue, setPendingValue] = React.useState<Employee | null>(
		null,
	);
	const theme = useTheme();

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setPendingValue(value);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setValue(pendingValue);
		updateEmployeeInFilter(pendingValue);
		anchorEl?.focus();
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'employee-label' : undefined;

	return (
		<Box>
			<StyledButton
				disableRipple
				aria-describedby={id}
				onClick={handleClick}
			>
				<span>{value?.FullName || 'All Employees'}&nbsp;</span>
				<EditIcon />
			</StyledButton>
			<StyledPopper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement="bottom-start"
			>
				<ClickAwayListener onClickAway={handleClose}>
					<div>
						<AutocompleteComponent
							pendingValue={pendingValue}
							setPendingValue={setPendingValue}
							handleClose={handleClose}
							options={employees}
							optionLabelAttribute="FullName"
							loadingOptions={loadingEmployees}
							theme={theme}
						/>
					</div>
				</ClickAwayListener>
			</StyledPopper>
		</Box>
	);
}
